import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { User, MapPin, Phone, Mail, CreditCard } from "lucide-react";
import { EditableField } from "./EditableField";

/**
 * Renter Information Section for Rental Agreement
 */
export const RenterInfoSection = ({ renterInfo, setRenterInfo, isEditing }) => {
  return (
    <Card>
      <CardHeader className="pb-4">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <User className="w-4 h-4 text-primary" />
          RENTER INFORMATION
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <EditableField 
          label="Full Name" 
          value={renterInfo.name} 
          isEditing={isEditing}
          onChange={(v) => setRenterInfo({...renterInfo, name: v})} 
        />
        <EditableField 
          label="Address" 
          value={renterInfo.address} 
          isEditing={isEditing}
          onChange={(v) => setRenterInfo({...renterInfo, address: v})} 
          icon={<MapPin className="w-3.5 h-3.5" />} 
        />
        {isEditing ? (
          <div className="flex gap-2">
            <Input 
              value={renterInfo.city || ''} 
              onChange={(e) => setRenterInfo({...renterInfo, city: e.target.value})} 
              placeholder="City" 
              className="h-8 text-sm" 
            />
            <Input 
              value={renterInfo.province || ''} 
              onChange={(e) => setRenterInfo({...renterInfo, province: e.target.value})} 
              placeholder="Province" 
              className="h-8 text-sm w-24" 
            />
            <Input 
              value={renterInfo.postalCode || ''} 
              onChange={(e) => setRenterInfo({...renterInfo, postalCode: e.target.value})} 
              placeholder="Postal" 
              className="h-8 text-sm w-24" 
            />
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">
            {renterInfo.city}, {renterInfo.province} {renterInfo.postalCode}
          </p>
        )}
        <EditableField 
          label="Phone" 
          value={renterInfo.phone} 
          isEditing={isEditing}
          onChange={(v) => setRenterInfo({...renterInfo, phone: v})} 
          icon={<Phone className="w-3.5 h-3.5" />} 
        />
        <EditableField 
          label="Email" 
          value={renterInfo.email} 
          isEditing={isEditing}
          onChange={(v) => setRenterInfo({...renterInfo, email: v})} 
          icon={<Mail className="w-3.5 h-3.5" />} 
        />
        <Separator className="my-3" />
        <EditableField 
          label="Driver's License" 
          value={renterInfo.driversLicense} 
          isEditing={isEditing}
          onChange={(v) => setRenterInfo({...renterInfo, driversLicense: v})} 
          icon={<CreditCard className="w-3.5 h-3.5" />} 
        />
        <EditableField 
          label="License Expiry" 
          value={renterInfo.licenseExpiry} 
          isEditing={isEditing} 
          type="date"
          onChange={(v) => setRenterInfo({...renterInfo, licenseExpiry: v})} 
        />
        <EditableField 
          label="Date of Birth" 
          value={renterInfo.dateOfBirth} 
          isEditing={isEditing} 
          type="date"
          onChange={(v) => setRenterInfo({...renterInfo, dateOfBirth: v})} 
        />
      </CardContent>
    </Card>
  );
};

export default RenterInfoSection;
